import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const Container = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xl};
  text-align: center;
  background-color: ${props => props.theme.colors.background};
`;

const Logo = styled.img`
  width: 200px;
  margin-bottom: ${props => props.theme.spacing.xl};
`;

const ImageHome = styled.img`
  width: 100%;
  max-width: 320px;
  margin-bottom: ${props => props.theme.spacing.lg};
  border-radius: ${props => props.theme.borderRadius.medium};
  box-shadow: ${props => props.theme.shadows.small};
`;

const Title = styled(motion.h1)`
  font-size: 1.7rem;
  color: ${props => props.theme.colors.textPrimary};
  margin-bottom: ${props => props.theme.spacing.md};
  max-width: 400px;
  line-height: 1.1;
`;

const Subtitle = styled(motion.p)`
  font-size: 1.1rem;
  color: ${props => props.theme.colors.textSecondary};
  margin-bottom: ${props => props.theme.spacing.lg};
  max-width: 350px;
`;

const Description = styled(motion.p)`
  font-size: 0.98rem;
  color: ${props => props.theme.colors.textSecondary};
  margin-bottom: ${props => props.theme.spacing.lg};
  max-width: 320px;
  line-height: 1.4;
`;

const StartButton = styled(motion.button)`
  background-color: ${props => props.theme.colors.primary};
  color: white;
  padding: ${props => props.theme.spacing.md} ${props => props.theme.spacing.xl};
  border-radius: ${props => props.theme.borderRadius.medium};
  font-size: ${props => props.theme.typography.fontSize.h4};
  font-weight: 600;
  box-shadow: ${props => props.theme.shadows.medium};
  transition: transform ${props => props.theme.transitions.default},
              background-color ${props => props.theme.transitions.default};

  &:hover {
    transform: translateY(-2px);
    background-color: ${props => props.theme.colors.secondary};
  }

  &:active {
    transform: translateY(0);
  }
`;

const LandingPage = ({ onStart }) => {
  return (
    <Container>
      <Logo src="/logo.png" alt="Dermapuris Logo" />
      <ImageHome src="/imagehome.png" alt="Beauty" />
      <Title
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        Entdecken Sie Ihre perfekte Anti-Aging Routine
      </Title>
      <Subtitle
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4 }}
      >
        In nur 2 Minuten zu Ihrer personalisierten Hautanalyse
      </Subtitle>
      <Description
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6 }}
      >
        Unser wissenschaftlich fundiertes Quiz hilft Ihnen, Ihre individuellen Hautbedürfnisse zu verstehen und die optimale Anti-Aging-Lösung zu finden.
      </Description>
      <StartButton
        onClick={onStart}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Quiz jetzt starten
      </StartButton>
    </Container>
  );
};

export default LandingPage; 